export const constructLineLayerDefinition = {
    geometryType: 'esriGeometryPolyline',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 115.71960466027735,
        ymin: -33.25728078541408,
        xmax: 122.83245485185546,
        ymax: -24.637873586726585,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeSmallInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'constructtype',
            type: 'esriFieldTypeSmallInteger',
            alias: 'constructtype',
            editable: true,
            nullable: true
        },
        {
            name: 'lineid',
            type: 'esriFieldTypeInteger',
            alias: 'lineid',
            editable: true,
            nullable: true
        },
        {
            name: 'frompointid',
            type: 'esriFieldTypeString',
            alias: 'frompointid',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'topointid',
            type: 'esriFieldTypeString',
            alias: 'topointid',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'distance',
            type: 'esriFieldTypeDouble',
            alias: 'distance',
            editable: true,
            nullable: true
        },
        {
            name: 'position',
            type: 'esriFieldTypeString',
            alias: 'position',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'scalefactor',
            type: 'esriFieldTypeDouble',
            alias: 'scalefactor',
            editable: true,
            nullable: true
        },
        {
            name: 'distancenottoscale',
            type: 'esriFieldTypeDouble',
            alias: 'distancenottoscale',
            editable: true,
            nullable: true
        },
        {
            name: 'visible',
            type: 'esriFieldTypeString',
            alias: 'visible',
            editable: true,
            nullable: true,
            length: 5
        },
        {
            name: 'hiddenonenlargements',
            type: 'esriFieldTypeString',
            alias: 'hiddenOnEnlargements',
            editable: true,
            nullable: true,
            length: 1024
        }
    ]
};
